<script setup>
  import { computed } from 'vue';  
  import { useTidesStore } from "@/stores/TidesStore";
  import Icon from "@/components/icons/Icon.vue";
  import { useDateHelper } from '@/composables/useDateHelper'
  import { format } from 'date-fns';

  const tidesStore = useTidesStore();

  const props = defineProps({
    isTall: {
      type: Boolean,
      default: false
    }
  });

  const sunrise = computed(() => tidesStore.sunrise ? tidesStore.sunrise.timeFormatted : '--:--');
  const sunset = computed(() => tidesStore.sunset ? tidesStore.sunset.timeFormatted : '--:--');
  const moonrise = computed(() => tidesStore.moonrise ? tidesStore.moonrise.timeFormatted : '--:--');
  const moonset = computed(() => tidesStore.moonset ? tidesStore.moonset.timeFormatted : '--:--');
  const moonStatus = computed(() => tidesStore.moonStatus ? `${tidesStore.moonStatus.eventName}: ${tidesStore.moonStatus.timeFormatted}` : null);
</script>

<template>
  <div class="jwx-tide-spot__event-group" data-content="solunar" :data-is-tall="props.isTall">
    <div class="jwx-tide-spot__solunar-rise-set-events">
      <p class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-sunrise">
        <Icon name="sunrise" class="jwx-tide-spot__solunar-event-icon" />
        {{ sunrise }}
      </p>
      <p class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-sunset">
        <Icon name="sunset" class="jwx-tide-spot__solunar-event-icon" />
        {{ sunset }}
      </p>
      <p class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-moonrise">
        <Icon name="moonrise" class="jwx-tide-spot__solunar-event-icon" />
        {{ moonrise }}
      </p>
      <p class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-moonset">
        <Icon name="moonset" class="jwx-tide-spot__solunar-event-icon" />
        {{ moonset }}
      </p>
    </div>
    <p v-if="moonStatus" class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-moonstatus">
      {{ moonStatus }}
    </p>
  </div>
</template>